/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SidlorealitInputs */

const cs_enum_sidlorealit = /** @type {(inputs: Enum_SidlorealitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SídloRealit`)
};

const en_enum_sidlorealit = /** @type {(inputs: Enum_SidlorealitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SídloRealit`)
};

/**
* | output |
* | --- |
* | "SídloRealit" |
*
* @param {Enum_SidlorealitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sidlorealit = /** @type {((inputs?: Enum_SidlorealitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SidlorealitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sidlorealit(inputs)
	return cs_enum_sidlorealit(inputs)
});